//
// BooleanInput
//
// The BooleanInput is a Yes | No segmented button with the option to clear it

import React from 'react'
import { useStore } from '../stores'

import { HView } from '../appview'
import { Bar, Button, Icon } from '../components'
import { test_empty, test_true } from '../utils/utils'

export const BooleanInput = React.forwardRef((props, ref) => {
    const { className, value, onSetValue, ua, ...other } = props
    const uaName = 'ua-action' + (ua ? '-' + ua : '')
    let classes = 'cc-BooleanInput ' + uaName
    if (className) classes += ' ' + className
    const readOnly = !onSetValue
    if (readOnly) classes += ' cc-readonly'

    const { app } = useStore()

    const _onSetValue = newValue => {
        onSetValue && onSetValue(newValue)
    }

    // inputvalue can only be true, false, or null after this
    const inputvalue = test_empty(value) ? null : test_true(value)

    return (
        <HView className={classes} vcenter ref={ref} {...other}>
            <Bar raised>
                <Button
                    active={inputvalue === true}
                    title={app.text('Yes')}
                    onClick={e => _onSetValue(true)}
                >
                    {app.text('Yes')}
                </Button>
                <Button
                    active={inputvalue === false}
                    title={app.text('No')}
                    onClick={e => _onSetValue(false)}
                >
                    {app.text('No')}
                </Button>
            </Bar>
            {readOnly ? undefined : inputvalue !== null ? (
                <Button
                    className="clear"
                    title={app.text('Clear')}
                    onClick={e => _onSetValue(null)}
                >
                    <Icon name="remove" size={'text'} />
                </Button>
            ) : (
                <Button className="clear none">
                    <Icon name="none" size={'text'} />
                </Button>
            )}
        </HView>
    )
})
